import { PrivateDeploy } from '@/config/private-deploy'
import { requestApi } from '@/lib/request.js'

class Login {
    // 使用credamo的登录项目，还是用自己的登录项目
    static getLoginPrefix(){
        if(PrivateDeploy.isPrivate()){
            return './'
        }
        return './login.html'
    }

    static getDefaultRedirect(){
        if(PrivateDeploy.isPrivate()){
            return PrivateDeploy.getDefaultRedirect()
        }
        return "./#/home"
    }

    static loginUser(loginId, password, memorymeFlag, rid) {
        const data = { loginId, password, memorymeFlag, rid }
        return requestApi('/sys/login', 'post', {}, data, true)
    }

    static getEmailCode(obj) {
        const url = '/emailcode/get'

        const data = Object.assign({}, obj)
        return requestApi(url, 'get', {}, data, true)
    }
    
    static changePwd(obj) {
        const url = '/changePwd'
        const data = Object.assign({}, {
            newPassword: obj.newPassword,
            confirmPassword: obj.confirmPassword,
            phone: obj.phone,
            smsCode: obj.smsCode,
            userDevice: obj.userDevice,
            email: obj.email,
        })
        return requestApi(url, 'post', { 'Content-Type': 'application/x-www-form-urlencoded' }, data, true)
    }
    static getSmsCode(obj) {
        const url = '/noauth/sms/get/code'
        const data = Object.assign({}, obj)
        return requestApi(url, 'get', {}, data, true)
    }
    static loginOrRegister(data) {
        return requestApi('/sys/loginOrRegister', 'post', {}, data, true)
    }
    static getCompanyInfo(shortUrl) {
        const data = Object.assign({}, {})
        return requestApi('/noauth/company/get/' + shortUrl, 'get', {}, data, true)
    }
    static getWxLogin() {
        return requestApi('/weixin/getTicket', 'get', {}, {}, true)
    }
    static getStates(sceneId) {
        return requestApi(`/weixin/isLogin/${sceneId}`, 'get', {}, {}, true)
    }
    static safeVerify(data) {
        return requestApi('/sys/verify', 'get', {}, data, true)
    }
    static resetPassword(data) {
        return requestApi('/sys/changePassword', 'post', {}, data, true)
    }
    static googleLogin(obj) {
        return requestApi('/sys/google/login', 'post', { "Content-Type": "application/json" }, obj, true)
    }
    static googleRegister(obj) {
        return requestApi('/sys/google/passwordLogin', 'post', { "Content-Type": "application/json" }, obj, true)
    }
    static googleBindLogin(obj) {
        return requestApi('/sys/google/bindEmailLogin', 'post', { "Content-Type": "application/json" }, obj, true)
    }
    static thirdRegisterOrBind(data) {
        return requestApi('/third/sys/oauth/login/registerOrBind', 'post', { "Content-Type": "application/json" }, data, true)
    }
    static logOut() {
        return requestApi('/sys/logout', 'get', {}, {})
    }
}

export {
    Login
}



// WEBPACK FOOTER //
// ./src/models/login.js